import { useEffect, useState } from 'react';
export function useSet(arr) {
  const [set, setSet] = useState(() => new Set(arr));
  useEffect(() => {
    setSet(new Set(arr));
  }, [arr]);
  return set;
}